// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"5173b1e6","513":"390d393a","703":"057be68a","787":"456e626f"}[chunkId] + ".chunk.js";
};